import flex from "../../styles/flex";
import fonts from "../../styles/fonts";
import palette from "../../styles/palette";

export default {
    container: {
        ...flex.flexColumns,
        minHeight: "100vh"
    } as React.CSSProperties,

    homeIconContainer: {
        padding: 10, textAlign: "center"
    } as React.CSSProperties,
    homeIcon: {
        width: "100%",
        maxWidth: 30,
        marginBottom: 10
    } as React.CSSProperties,
    menuItemsTopContainer: {
        ...flex.flexAuto
    } as React.CSSProperties,
    menuItemsContainer: {
        ...flex.flexFill,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    } as React.CSSProperties,
    menuItemsContainerInner: {
        padding: 10
    } as React.CSSProperties,
    menuItem: {
        position: 'relative',
        cursor: 'pointer',
        textAlign: "center",
    } as React.CSSProperties,
    menuItemSelected: {
        color: palette.active.primary,
    } as React.CSSProperties,
    tooltip: {
        ...fonts.tooltip,
        backgroundColor: palette.bg.tooltip,
        position: "fixed",
        animation: `tooltip-left-right 0.3s forwards`,
        marginLeft: 35,
        minWidth: 120,
        textAlign: 'center',
        whiteSpace: "nowrap",
        color: "white",
        padding: 7,
        borderRadius: 5,
        transformOrigin: "0% 50%",
        zIndex: 99999,
    } as React.CSSProperties,
    tooltipHidden: {
        display: 'none',
    } as React.CSSProperties,
}